import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import viewPassword from './assets/view.svg';
import { Icon } from '../Icon';
import './PasswordField.scss';
export const PasswordField = ({ className = '', placeholder = 'Password', value, onChange, id = '', }) => {
    const [passwordShown, setPasswordShown] = useState(false);
    const handleChange = useCallback((event) => {
        onChange(event);
    }, [onChange]);
    const togglePasswordVisibility = useCallback(() => {
        setPasswordShown((shownValue) => !shownValue);
    }, []);
    return (React.createElement("div", { className: classnames('passwordfield-wrapper', {
            [className]: className,
        }) },
        React.createElement("input", { className: "password-input", type: passwordShown ? 'text' : 'password', placeholder: placeholder, value: value, id: id, onChange: handleChange }),
        React.createElement("button", { className: "view", type: "button", onClick: togglePasswordVisibility },
            React.createElement(Icon, { source: viewPassword, altText: "view password" }))));
};
//# sourceMappingURL=PasswordField.js.map